import Icon0G from './../../assets/image/ecosystem/Icon0G.png'
import IconMomentum from './../../assets/image/ecosystem/icon_Momentum.png'
import Icon_AllInX from './../../assets/image/ecosystem/icon_AllInX.png'
import Icon_PinAI from './../../assets/image/ecosystem/icon_PinAI.png'
import Icon_Circle from './../../assets/image/ecosystem/icon_Circle.png'
import IconHamster from './../../assets/image/ecosystem/icon_Hamster.png'
import humaIcon from '@/assets/image/ecosystem/icon_huma.png'
import PharosIcon from '@/assets/image/ecosystem/icon_Pharos.png'
import dotswapIcon from '@/assets/image/ecosystem/icon_Dotswap.png'
import IconKupila from '@/assets/image/ecosystem/icon_kupila.png'
import IconKiteAI from '@/assets/image/ecosystem/icon_kiteAI.png'
import IconSolayer from '@/assets/image/ecosystem/icon_solayer.png'
import yalaIcon from '@/assets/image/ecosystem/icon_Yala.png'
import sproutIcon from '@/assets/image/ecosystem/icon_Sprout.png'
import takerIcon from '@/assets/image/ecosystem/icon_Taker.png'
import n42Icon from '@/assets/image/ecosystem/icon_N42.png'
import protocolCATIcon from '@/assets/image/ecosystem/icon_ProtocolCAT.png'
import cicadaIcon from '@/assets/image/ecosystem/icon_CICADA.png'
import IconZkpass from '@/assets/image/ecosystem/Icon_Zkpass.png'
import IconPhala from '@/assets/image/ecosystem/Icon_Phala.png'
import IconAeon from '@/assets/image/ecosystem/Icon_Aeon.png'
import IconBitFi from '@/assets/image/ecosystem/Icon_BitFi.png'
import IconBorderless from '@/assets/image/ecosystem/Icon_Borderless.png'
import IconOrbiter from '@/assets/image/ecosystem/Icon_Orbiter.png'
import IconPara from '@/assets/image/ecosystem/Icon_Para.png'
import IconAsseto from '@/assets/image/ecosystem/Icon_Asseto.png'
import IconKredete from '@/assets/image/ecosystem/Icon_Kredete.png'
import IconRiscZero from '@/assets/image/ecosystem/icon_RISC_Zero.png'
import IconBlockStreet from '@/assets/image/ecosystem/icon_BlockStreet.png'
import IconBlockWare from '@/assets/image/ecosystem/icon_Blockware.png'
import IconKai from '@/assets/image/ecosystem/icon_KAI.png'
import IconZO from '@/assets/image/ecosystem/icon_ZO.png'
import IconVeniceFi from '@/assets/image/ecosystem/icon_VeniceFi.png'
import IconBitCoin from '@/assets/image/ecosystem/icon_Bitcoin.png'
import IconSolana from '@/assets/image/ecosystem/icon_Solana.png'
import IconSui from '@/assets/image/ecosystem/icon_Sui.png'
import IconMetaAlpha from '@/assets/image/ecosystem/icon_MetaAlpha.png'
import IconAnchorageDigital from '@/assets/image/ecosystem/icon_AnchorageDigital.png'
import IconBitgo from '@/assets/image/ecosystem/icon_Bitgo.png'
import IconCeffu from '@/assets/image/ecosystem/icon_Ceffu.png'
import IconCobo from '@/assets/image/ecosystem/icon_Cobo.png'
import IconGalaxy from '@/assets/image/ecosystem/icon_Galaxy.png'
import IconNexus from '@/assets/image/ecosystem/icon_Nexus.png'
import IconSega from '@/assets/image/ecosystem/icon_Sega.png'
import IconBluefin from '@/assets/image/ecosystem/icon_Bluefin.png'
import IconAlphafi from '@/assets/image/ecosystem/icon_Alphafi.png'
import IconAxal from '@/assets/image/ecosystem/icon_axal.png'
import IconTakara from '@/assets/image/ecosystem/icon_Takara.png'
import IconBitOrigin from '@/assets/image/ecosystem/icon_BitOrigin.png'
import IconTurnkey from '@/assets/image/ecosystem/icon_Turnkey.png'
import IconPrivy from '@/assets/image/ecosystem/icon_Privy.png'
import IconWorldPay from '@/assets/image/ecosystem/icon_WorldPay.png'
import IconUpay from '@/assets/image/ecosystem/icon_Upay.png'


const mockList =  [
  {
    icon: IconBitCoin,
    jumpUrl: 'https://bitcoin.org/en/',
    partner: '',
    title: 'Bitcoin',
    content: 'Bitcoin is an open source censorship-resistant peer-to-peer immutable network. ',
    tagList: [
      {
        themeColor: 'rgba(255, 255, 255, 0.16)',
        name: 'Chain Ecosystem',
        url: ''
      }
    ]
  }, {
    icon: IconSolana,
    jumpUrl: 'https://solana.com/',
    partner: '',
    title: 'Solana',
    content: 'The high performance network powering internet capital markets, payments, and crypto applications. ',
    tagList: [
      {
        themeColor: 'rgba(255, 255, 255, 0.16)',
        name: 'Chain Ecosystem',
        url: ''
      }
    ]
  }, {
    icon: IconSui,
    jumpUrl: 'https://sui.io/',
    partner: '',
    title: 'Sui',
    content: 'Layer 1 blockchain designed to make digital asset ownership fast, private, secure, and accessible to everyone. ',
    tagList: [
      {
        name: 'Chain Ecosystem',
        url: ''
      }
    ]
  }, {
    icon: Icon_Circle,
    jumpUrl: 'https://www.circle.com/',
    // partner: 'https://x.com/Vishwa_xyz/status/1963225625272987811',
    title: 'Circle',
    content: 'Circle helps businesses and developers harness the power of USDC for payments and commerce.',
    tagList: [
      {
        name: 'Stablecoin',
        url: ''
      }
    ]
  }, {
    icon: IconKiteAI,
    jumpUrl: 'https://gokite.ai/',
    partner: 'https://x.com/Vishwa_xyz/status/1961199374987416040',
    title: 'KiteAI',
    content: 'The Purpose-built Layer 1 for AI.',
    tagList: [
      {
        name: 'Infra',
        url: ''
      },
      {
        name: 'AI Agent',
        url: ''
      },
    ]
  }, {
    icon: Icon0G,
    jumpUrl: 'https://0g.ai/',
    partner: 'https://x.com/Vishwa_xyz/status/1879918778433319061',
    title: '0G Labs',
    content: 'The first decentralized AI operation system.',
    tagList: [
      {
        name: 'Infra',
        url: ''
      }, {
        name: 'AI Agent',
        url: ''
      }
    ]
  }, {
    icon: IconSolayer,
    jumpUrl: 'https://app.solayer.org/',
    partner: 'https://x.com/Vishwa_xyz/status/1928015535024837067',
    title: 'Solayer',
    content: 'Hardware-accelerated SVM layer 1, scaled infinitely, streamed in real time.',
    tagList: [
      {
        name: 'Infra',
        url: ''
      }, {
        name: 'Payment',
        url: ''
      }
    ]
  }, {
    icon: humaIcon,
    title: 'Huma',
    jumpUrl: 'https://huma.finance/',
    partner: '',
    content: 'Huma powers financing of global payments, with instant access to liquidity anywhere, anytime.',
    tagList: [
      {
        name: 'Payment',
        url: ''
      }, {
        name: 'Yield',
        url: ''
      }
    ]
  }, {
    icon: Icon_PinAI,
    jumpUrl: 'https://www.pinai.com',
    partner: 'https://x.com/Vishwa_xyz/status/1961444050474791235',
    title: 'PinAI',
    content: 'PIN AI is the First Personal AI Network.',
    tagList: [
      {
        name: 'AI Agent',
        url: ''
      }
    ]
  }, {
    icon: PharosIcon,
    jumpUrl: 'https://www.pharosnetwork.xyz/',
    partner: 'https://x.com/Vishwa_xyz/status/1981360557383991636',
    title: 'Pharos',
    content: 'Programmable Open Financial Layer 1 for RWAs & Crosschain Liquidity.',
    tagList: [
      {
        name: 'RWA',
        url: ''
      }
    ]
  }, {
    icon: IconRiscZero,
    jumpUrl: 'https://risczero.com/',
    partner: 'https://x.com/Vishwa_xyz/status/1978829068159074636',
    title: 'Risc Zero',
    content: 'Building high-performance ZK systems to power the next era of computing.',
    tagList: [
      {
        name: 'ZK',
        url: ''
      }, {
        themeColor: 'rgba(255, 255, 255, 0.16)',
        name: 'DevTool',
        url: ''
      }
    ]
  }, {
    icon: IconMetaAlpha,
    jumpUrl: 'https://www.metalpha.net/',
    partner: '',
    title: 'MetaAlpha',
    content: 'A global leading provider of blockchain and trading technology solutions.',
    tagList: [
      {
        themeColor: '',
        name: 'Infra',
        url: ''
      }
    ]
  }, {
    icon: IconAnchorageDigital,
    jumpUrl: 'https://www.anchorage.com/',
    partner: '',
    title: 'Anchorage Digital',
    content: 'The trusted crypto platform for innovators and investors.',
    tagList: [
      {
        themeColor: '',
        name: 'Custodian',
        url: ''
      }
    ]
  }, {
    icon: IconCobo,
    jumpUrl: 'https://www.cobo.com/',
    partner: '',
    title: 'Cobo',
    content: 'Cobo is a trusted custody and wallet infrastructure provider that simplifies digital asset security for organizations and developers.',
    tagList: [
      {
        name: 'Custodian',
        url: ''
      }
    ]
  }, {
    icon: IconCeffu,
    jumpUrl: 'https://www.ceffu.com/',
    partner: '',
    title: 'Ceffu',
    content: 'Enterprise-grade custody and liquidity solutions built for institutions. ',
    tagList: [
      {
        name: 'Custodian',
        url: ''
      }
    ]
  }, {
    icon: IconBitgo,
    jumpUrl: 'https://www.bitgo.com/',
    partner: '',
    title: 'Bitgo',
    content: 'Accelerating the transition of the existing financial system to a digital asset economy.',
    tagList: [
      {
        name: 'Custodian',
        url: ''
      }
    ]
  }, {
    icon: IconNexus,
    jumpUrl: 'https://nexus.xyz/',
    partner: 'https://x.com/Vishwa_xyz/status/1951296471896375566?s=20',
    title: 'Nexus',
    content: 'The Layer 1 for Verifiable Finance.',
    tagList: [
      {
        name: 'Infra',
        url: ''
      }
    ]
  }, {
    icon: IconGalaxy,
    jumpUrl: 'https://www.galaxy.com/',
    partner: '',
    title: 'Galaxy',
    content: 'Global leader in digital assets and data center infrastructure. ',
    tagList: [
      {
        name: 'Infra',
        url: ''
      }
    ]
  }, {
    icon: IconMomentum,
    jumpUrl: 'https://app.mmt.finance/trade',
    partner: 'https://x.com/Vishwa_xyz/status/1965113854599352741',
    title: 'Momentum',
    content: 'The central liquidity engine of the Move ecosystem, built on Sui.',
    tagList: [
      {
        name: 'Yield',
        url: ''
      }, {
        name: 'DeFi',
        url: ''
      }
    ]
  }, {
    icon: IconSega,
    jumpUrl: 'https://sega.so/',
    partner: '',
    title: 'Sega',
    content: 'First & Leading ve(3,3) DEX & Attention Market on SonicSVM & Solana.',
    tagList: [
      {
        name: 'Yield',
        url: ''
      }, {
        name: 'DeFi',
        url: ''
      }
    ]
  }, {
    icon: IconBluefin,
    jumpUrl: 'https://trade.bluefin.io/',
    partner: '',
    title: 'Bluefin',
    content: 'Decentralized Everything Exchange. ',
    tagList: [
      {
        name: 'Yield',
        url: ''
      }, {
        name: 'DeFi',
        url: ''
      }
    ]
  }, {
    icon: IconAlphafi,
    jumpUrl: 'https://linktr.ee/AlphaFi#502232708',
    partner: '',
    title: 'Alphafi',
    content: 'Where DeFi turns Alpha.',
    tagList: [
      {
        name: 'Yield',
        url: ''
      }, {
        name: 'DeFi',
        url: ''
      }
    ]
  }, {
    icon: IconAxal,
    jumpUrl: 'https://axal.com/',
    partner: 'https://x.com/Vishwa_xyz/status/1921299530546295128?s=20',
    title: 'Axal',
    content: 'Earn more with the world\'s yield primitive.',
    tagList: [
      {
        name: 'Yield',
        url: ''
      }, {
        name: 'DeFi',
        url: ''
      }
    ]
  }, {
    icon: IconTakara,
    jumpUrl: 'https://app.takaralend.com/',
    partner: '',
    title: 'Takara',
    content: 'Connecting the world onchain with simple, powerful finance.',
    tagList: [
      {
        name: 'Yield',
        url: ''
      }, {
        name: 'DeFi',
        url: ''
      }
    ]
  },  {
    icon: IconBitOrigin,
    jumpUrl: 'https://bitorigin.io/',
    partner: '',
    title: 'BitOrigin',
    content: 'Sustainable American Crypto Mining.',
    tagList: [
      {
        name: 'Infra',
        url: ''
      }
    ]
  }, {
    icon: IconPrivy,
    jumpUrl: 'https://www.privy.io/',
    partner: '',
    title: 'Privy',
    content: 'Wallet infrastructure for winning teams. Powering 100M+ accounts, securing billions in volume. Embed crypto rails into your product seamlessly with one API.',
    tagList: [
      {
        name: 'Wallet',
        url: ''
      }
    ]
  }, {
    icon: IconTurnkey,
    jumpUrl: 'https://www.turnkey.com/',
    partner: '',
    title: 'Turnkey',
    content: 'Secure, scalable, and programmable crypto wallet infrastructure. The future of finance is open.',
    tagList: [
      {
        name: 'Wallet',
        url: ''
      }
    ]
  }, {
    icon: IconWorldPay,
    jumpUrl: 'https://www.worldpay.com/zh-CN',
    partner: '',
    title: 'WorldPay',
    content: 'Worldpay is an industry leading payments technology and solutions company with unique capabilities to power omni-commerce across the globe.',
    tagList: [
      {
        name: 'Payment',
        url: ''
      }
    ]
  }, {
    icon: IconKredete,
    jumpUrl: 'https://www.kredete.io/',
    partner: 'https://x.com/Vishwa_xyz/status/1972692856390418603',
    title: 'Kredete',
    content: 'The #1 most loved credit builder & money transfer ',
    tagList: [
      {
        name: 'Payment',
        url: ''
      }, {
        name: 'Stablecoin',
        url: ''
      }
    ]
  }, {
    icon: yalaIcon,
    title: 'Yala',
    jumpUrl: 'https://yala.org/',
    partner: '',
    content: 'Bring Bitcoin\'s liquidity across blockchains.',
    tagList: [
      {
        name: 'Stablecoin',
        url: ''
      }, {
        name: 'BTC',
        url: ''
      }
    ]
  }, {
    icon: IconBitFi,
    jumpUrl: 'https://www.bitfi.one/',
    partner: 'https://x.com/Vishwa_xyz/status/1940795442859856219',
    title: 'BitFi',
    content: 'An on-chain asset management platform bridging CeFi yields and DeFi returns for both institutions and individuals. ',
    tagList: [
      {
        name: 'Yield',
        url: ''
      }, {
        name: 'CeDeFi',
        url: ''
      },
    ]
  }, {
    icon: IconBlockStreet,
    jumpUrl: 'https://blockstreet.money/',
    partner: '',
    title: 'Block Street',
    content: 'Unified Liquidity Layer for Tokenized Assets.',
    tagList: [
      {
        name: 'Yield',
        url: ''
      }, {
        name: 'RWA',
        url: ''
      }
    ]
  }, {
    icon: IconAsseto,
    jumpUrl: 'https://asseto.finance/',
    partner: 'https://x.com/Vishwa_xyz/status/1943208861269393786',
    title: 'Asseto Finance',
    content: 'The Ultimate RWA Launchpad Based on Tokenization.',
    tagList: [
      {
        name: 'Yield',
        url: ''
      }, {
        name: 'Stablecoin',
        url: ''
      }, {
        name: 'RWA',
        url: ''
      }
    ]
  }, {
    icon: cicadaIcon,
    jumpUrl: 'https://cicada.finance',
    partner: 'https://x.com/Vishwa_xyz/status/1887641764044947566',
    title: 'CICADA',
    content: 'Cicada, the new generation market, allows degens to get the perfect intersection between liquidity and real yield assets, and effectively reconstructs the distribution process of real yield to the crypto world.',
    tagList: [
      {
        name: 'Yield',
        url: ''
      }, {
        name: 'CeDeFi',
        url: ''
      }
    ]
  }, {
    icon: IconAeon,
    jumpUrl: 'https://aeon.xyz/',
    partner: 'https://x.com/Vishwa_xyz/status/1948051967047086365',
    title: 'Aeon',
    content: 'AEON is the next-generation payment protocol supporting all major chains to pioneer payment abstraction for crypto mass adoption.',
    tagList: [
      {
        name: 'Payment',
        url: '',
      }
    ]
  }, {
    icon: IconPhala,
    jumpUrl: 'https://phala.network/',
    partner: '',
    title: 'Phala Network',
    content: 'Your open-source, trustless cloud. Powered by TEE, Governed by code, and Owned by you.',
    tagList: [
      {
        name: 'Infra',
        url: ''
      }, {
        name: 'ZK',
        url: ''
      }
    ]
  }, {
    icon: IconZkpass,
    jumpUrl: 'https://zkpass.org/',
    partner: '',
    title: 'ZKPass',
    content: 'An oracle protocol that enables private internet data to be verifiable on-chain.',
    tagList: [
      {
        name: 'Infra',
        url: ''
      }, {
        name: 'ZK',
        url: ''
      }
    ]
  }, {
    icon: IconBlockWare,
    jumpUrl: 'https://www.blockwaresolutions.com/',
    partner: 'https://x.com/Vishwa_xyz/status/1932944973898420314',
    title: 'Blockware',
    content: 'Bitcoin Mining as a Service (MaaS)',
    tagList: [
      {
        name: 'BTC',
        url: ''
      }
    ]
  }, {
    icon: IconKai,
    jumpUrl: 'https://kai.finance/',
    partner: 'https://x.com/Vishwa_xyz/status/1968786754946654635',
    title: 'Kai Finance',
    content: 'Leveraged yield farming on Sui',
    tagList: [
      {
        name: 'Yield',
        url: ''
      }, {
        name: 'CeDeFi',
        url: ''
      }
    ]
  }, {
    icon: IconZO,
    jumpUrl: 'https://www.zofai.io/',
    partner: 'https://x.com/Vishwa_xyz/status/1967619664302735787',
    title: 'ZO',
    content: 'The First Intelligent Perpetual Protocol.',
    tagList: [
      {
        name: 'Yield',
        url: ''
      }, {
        name: 'CeDeFi',
        url: ''
      }
    ]
  }, {
    icon: IconBorderless,
    jumpUrl: 'https://borderless.xyz/',
    partner: '',
    title: 'Borderless',
    content: 'The largest stablecoin orchestration network enabling conversions between stablecoins and local banking rails in 50+ countries for financial institutions, payments companies, fintechs, and corporate entities.',
    tagList: [
      {
        name: 'Payment',
        url: ''
      }, {
        name: 'Stablecoin',
        url: ''
      }
    ]
  }, {
    icon: IconOrbiter,
    jumpUrl: 'https://www.orbiter.finance/',
    partner: '',
    title: 'Orbiter Finance',
    content: 'A ZK based cross-rollup bridge that offers secure, low cost and almost instant transfer.',
    tagList: [
      {
        name: 'Infra',
        url: ''
      }
    ]
  }, {
    icon: IconPara,
    jumpUrl: 'https://www.getpara.com/',
    partner: '',
    title: 'Para Wallet',
    content: 'The most comprehensive wallet and authentication suite for crypto applications.',
    tagList: [
      {
        name: 'Wallet',
        url: ''
      }
    ]
  }, {
    icon: IconUpay,
    jumpUrl: 'https://upay.best/zh-CN',
    partner: '',
    title: 'Upay',
    content: 'Seamless, Secure & Instant Crypto Payments.',
    tagList: [
      {
        name: 'Payment',
        url: ''
      }
    ]
  }, {
    icon: Icon_AllInX,
    jumpUrl: 'https://www.allinx.io',
    partner: 'https://x.com/Vishwa_xyz/status/1964355815222960556',
    title: 'All InX',
    content: 'The CeDeFi Exchange of Everything.',
    tagList: [
      {
        name: 'RWA',
        url: ''
      }
    ]
  }, {
    icon: protocolCATIcon,
    jumpUrl: 'https://catprotocol.org/',
    partner: 'https://x.com/Vishwa_xyz/status/1882248193339265287',
    title: 'CAT Protocol',
    content: 'First ever miner-validated token protocol on Bitcoin using Satoshi\'s OP_CAT, no indexer needed. Make OP_CAT Live Again.',
    tagList: [
      {
        name: 'Infra',
        url: ''
      }, {
        name: 'BTC',
        url: ''
      }
    ]
  },  {
    icon: IconKupila,
    jumpUrl: 'https://www.kulipa.xyz/',
    partner: 'https://x.com/Vishwa_xyz/status/1942292560741032104',
    title: 'Kulipa',
    content: 'Kulipa helps crypto wallets issue branded payment cards to their users.',
    tagList: [
      {
        name: 'Payment',
        url: ''
      }
    ]
  }, {
    icon: n42Icon,
    jumpUrl: 'https://n42.world/',
    partner: 'https://x.com/Vishwa_xyz/status/1880255039094092148',
    title: 'N42',
    content: 'The new-generation Web3 high-performance ecological platform, making value within easy reach.',
    tagList: [
      {
        name: 'Infra',
        url: ''
      }, {
        name: 'Wallet',
        url: ''
      }
    ]
  }, {
    icon: IconVeniceFi,
    jumpUrl: 'https://venicefi.com/',
    partner: 'https://x.com/Vishwa_xyz/status/1935873896726814924',
    title: 'Venice Fi',
    content: 'Venice is a fixed rate lending market across the BTC/stablecoin complex.',
    tagList: [
      {
        name: 'BTC',
        url: ''
      }, {
        name: 'DeFi',
        url: ''
      }
    ]
  }, {
    icon: IconHamster,
    jumpUrl: 'https://hamsternet.ai/',
    title: 'Hamster',
    content: 'One-stop Development Automation Experience with Process Safety and Privacy.',
    tagList: [
      {
        name: 'Infra',
        url: ''
      }, {
        name: 'DevTool',
        url: ''
      }
    ]
  }, {
    icon: sproutIcon,
    title: 'Sprout',
    jumpUrl: 'https://www.sproutfi.xyz/',
    partner: '',
    content: 'Building the first mobile app that makes crypto investing easy for everyone. Sprout enables crypto-ready users in emerging markets to build wealth with automated investment strategies tailored to each user\'s risk preference.',
    tagList: [
      {
        name: 'Yield',
        url: ''
      },
      {
        name: 'DeFi',
        url: ''
      }
    ]
  }, {
    icon: takerIcon,
    title: 'Taker',
    jumpUrl: 'https://www.taker.xyz/',
    partner: 'https://x.com/Vishwa_xyz/status/1861588380037062881',
    content: 'Yield bearing layer of BTC.',
    tagList: [
      {
        name: 'Yield',
        url: ''
      }, {
        name: 'BTC',
        url: ''
      }
    ]
  }, {
    icon: dotswapIcon,
    title: 'DotSwap',
    jumpUrl: 'https://www.dotswap.app/',
    partner: '',
    content: 'DotSwap—One-stop DeFi solution for Runes, BRC20, ARC20, and CAT20.',
    tagList: [
      {
        name: 'Yield',
        url: ''
      }, {
        name: 'DeFi',
        url: ''
      }, {
        name: 'BTC',
        url: ''
      }
    ]
  }
]

export default mockList